import qc from 'qc'
import { resetAndStopAnimation } from '@ps/bridge/qc/node'
import _ from 'lodash'
import { recoverPropToDefault, updateScaleTween } from '@ps/workbench/animation'
import nodePool from '@ps/bridge/qc/node-pool'
import store from '@ps/store'
import { updatePositionTween } from '@ps/workbench/animation'
import { checkIsSupportTweenScaleSplit } from '@ps/store/workbench/visual-program/utils'
import {
  removeUnSplitPropValue,
  setUnSplitPropValue,
} from '@ps/bridge/qc/scripts/editor'
import { scripts } from '@ps/bridge/qc/scripts'

export const updateAnimation = ({
  animations,
  node,
}: {
  animations: qc.Behaviour[]
  node: qc.Node
}): void => {
  animations.forEach((item) => {
    const script = _.find(node.scripts, (el) => {
      // @ts-ignore
      return el.uuid === item.uuid
    })
    for (const key in _.omit(item, 'uuid')) {
      if (key === 'curve') {
        // @ts-ignore
        script[key].keys = item[key].keys
      } else {
        // @ts-ignore
        script[key] = item[key]
      }
    }
    const isSupportTweenScale = checkIsSupportTweenScaleSplit()
    // 存在位移动画更新位移动画坐标
    if (script && script.class === 'qc.TweenPosition') {
      updatePositionTween(node)
    } else if (
      isSupportTweenScale &&
      script &&
      script.class === 'qc.TweenScale'
    ) {
      updateScaleTween(node)
    }
  })
}

export const addAnimation = ({
  animations,
  node,
}: {
  animations: qc.Behaviour[]
  node: qc.Node
}): void => {
  animations.forEach((script) => {
    node.scripts.push(script)
  })
  resetAndStopAnimation(node)
  const isSupportTweenScale = checkIsSupportTweenScaleSplit()
  // 存在位移动画更新位移动画坐标
  if (animations.some((item) => item.class === 'qc.TweenPosition')) {
    updatePositionTween(node)
    // 横竖屏默认不拆分位移动画和缩放动画参数
    const list = animations.filter((item) => item.class === 'qc.TweenPosition')
    list.forEach((item) => {
      // 复制动画的情况，优先使用unSplitPropValue和adapterData的缓存数据
      if (typeof item.unSplitPropValue !== 'undefined') {
        setUnSplitPropValue(
          node,
          `tweenPosition-${item.uuid}`,
          item.unSplitPropValue,
        )
      } else {
        setUnSplitPropValue(node, `tweenPosition-${item.uuid}`, true)
      }
      if (typeof item.adapterData !== 'undefined') {
        const vh = node.getScript(scripts.verticalHorizontal.name)
        vh.adapterData.tweenPosition[item.uuid] = item.adapterData
      }
    })
  } else if (
    isSupportTweenScale &&
    animations.some((item) => item.class === 'qc.TweenScale')
  ) {
    updateScaleTween(node, true)
    // 横竖屏默认不拆分位移动画和缩放动画参数
    const list = animations.filter((item) => item.class === 'qc.TweenScale')
    list.forEach((item) => {
      // 复制动画的情况，优先使用unSplitPropValue和adapterData的缓存数据
      if (typeof item.unSplitPropValue !== 'undefined') {
        setUnSplitPropValue(
          node,
          `tweenScale-${item.uuid}`,
          item.unSplitPropValue,
        )
        delete item.unSplitPropValue
      } else {
        setUnSplitPropValue(node, `tweenScale-${item.uuid}`, true)
      }
      if (typeof item.adapterData !== 'undefined') {
        const vh = node.getScript(scripts.verticalHorizontal.name)
        vh.adapterData.tweenScale[item.uuid] = item.adapterData
        delete item.adapterData
      }
    })
  }
}

export const removeAnimation = ({
  animations,
  node,
}: {
  animations: qc.Behaviour[]
  node: qc.Node
}): void => {
  node = nodePool.find(node.uuid)
  resetAndStopAnimation(node)
  // 获取需要删除的脚本
  const removeList = node.scripts.filter((item) => {
    return animations.some((el) => el.uuid === item.uuid)
  })
  // 重置动画脚本属性值
  removeList.forEach((script) => {
    recoverPropToDefault({
      animation: script,
      node: node,
    })
  })
  // 删除横竖屏拆分参数
  let list = animations.filter(
    (item) =>
      item.animationClassName === 'qc.TweenPosition' ||
      item.class === 'qc.TweenPosition',
  )
  list.forEach((item) => {
    removeUnSplitPropValue(node, `tweenPosition-${item.uuid}`)
  })
  list = animations.filter(
    (item) =>
      item.animationClassName === 'qc.TweenScale' ||
      item.class === 'qc.TweenScale',
  )
  list.forEach((item) => {
    removeUnSplitPropValue(node, `tweenScale-${item.uuid}`)
  })
  _.remove(node.scripts, (item) => {
    return removeList.some((el) => el.uuid === item.uuid)
  })
  // 存在位移动画更新位移动画坐标
  if (animations.some((item) => item.class === 'qc.TweenPosition')) {
    setTimeout(() => {
      updatePositionTween(node)
    })
  }
}

export const switchAnimation = ({
  animations,
  newAnimations,
  node,
  index,
}: {
  animations: qc.Behaviour[]
  newAnimations: qc.Behaviour[]
  node: qc.Node
  index: number
}): void => {
  removeAnimation({
    animations: animations,
    node,
  })
  _.remove(node.scripts, (item) => {
    // @ts-ignore
    return animations.some((el) => el.uuid === item.uuid)
  })

  // 根据目标位置插入脚本
  for (let i = 0; i < newAnimations.length; i++) {
    // @ts-ignore
    node.scripts.splice(index + i, 0, newAnimations[i])
  }
  resetAndStopAnimation(node)
  const isSupportTweenScale = checkIsSupportTweenScaleSplit()
  // 存在位移动画更新位移动画坐标
  if (newAnimations.some((item) => item.class === 'qc.TweenPosition')) {
    updatePositionTween(node)
    // 横竖屏默认不拆分位移动画和缩放动画参数
    const list = newAnimations.filter(
      (item) => item.class === 'qc.TweenPosition',
    )
    list.forEach((item) => {
      setUnSplitPropValue(node, `tweenPosition-${item.uuid}`, true)
    })
  } else if (
    isSupportTweenScale &&
    newAnimations.some((item) => item.class === 'qc.TweenScale')
  ) {
    updateScaleTween(node, true)
    // 横竖屏默认不拆分位移动画和缩放动画参数
    const list = newAnimations.filter((item) => item.class === 'qc.TweenScale')
    list.forEach((item) => {
      setUnSplitPropValue(node, `tweenScale-${item.uuid}`, true)
    })
  }

  store.dispatch('workspace/game/visualProgram/updateActionBySwitchAnimation', {
    animations,
    newAnimations,
  })
}

export const insertAnimation = ({
  animations,
  node,
  index,
}: {
  animations: qc.Behaviour[]
  node: qc.Node
  index: number
}): void => {
  node = nodePool.find(node.uuid)
  animations.forEach((script, i) => {
    node.scripts.splice(index + i, 0, script)
  })
}
